<template>
    <div class="IORequest">
        <box class="" :title="this.$t('nav-request-io')">
            <div class="px-3 pt-2">
                <v-form ref="form" v-model="form">
                    <!-- <v-row>
                        <v-col cols="12" sm="6">
                            <v-row>
                                <v-col class="max-width-text-title px-1 d-flex">
                                    <label class="my-auto">{{ $t("date") }} : </label>
                                </v-col>
                                <v-col>
                                    <dialog-date-picker :label="$t('date') + ':'" :initDate="initBeginDate"
                                        @dateResult="bDate" :disabled="true" />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-row class="mt-2 mt-sm-0">
                                <v-col class="max-width-text-title px-1 d-flex">
                                    <label class="my-auto">{{ $t("time") }} : </label>
                                </v-col>
                                <v-col>
                                    <dialog-time-picker :label="$t('time') + ':'" :initTime="initBeginTime"
                                        @dateResult="bTime" :disabled="true" />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row> -->

                    <v-row class="mt-2">
                        <v-col cols="12" sm="6">
                            <v-row>
                                <v-col class="max-width-text-title px-1 d-flex">
                                    <label class="my-auto">{{ $t("type") }} : </label>
                                </v-col>
                                <v-col>
                                    <v-radio-group v-model="ioParams.IoKind" row dense class="ma-0" hide-details="">
                                        <v-radio :label="$t('enter')" value="1" class="mx-0"></v-radio>
                                        <v-radio :label="$t('exit')" value="2"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row class="mt-2" v-if="clockVisible">
                        <v-col cols="12" sm="6">
                            <v-row>
                                <v-col class="max-width-text-title px-1 d-flex">
                                    <label class="my-auto">دستگاه ساعت: </label>
                                </v-col>
                                <v-col>
                                    <v-select solo :items="clockList" v-model="selectedClock" hide-details="">
                                        <template v-slot:prepend-item>
                                            <div class="px-2">
                                                <v-row>
                                                    <v-col><strong>نام ساعت</strong> </v-col>
                                                    <v-col><strong>شماره دستگاه</strong> </v-col>
                                                </v-row>
                                            </div>
                                            <v-divider class="mt-1"></v-divider>
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            <v-row>
                                                <v-col>{{ data.item.Name }}</v-col>
                                                <v-col>{{ data.item.MachineNo }}</v-col>
                                            </v-row>
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            {{ data.item.Name }}
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <!-- <v-row class="mt-2">
                        <v-col cols="12" sm="10">
                            <template>
                                <button @click="openCmera">
                                    ارسال عکس
                                </button>
                            </template>
                        </v-col>
                    </v-row> -->
                    <!-- <v-row class="mt-2">
                        <v-col cols="12" sm="10">
                          <v-file-input v-model="imageFile" label="File input"></v-file-input>
                          <canvas v-show="isPhotoTaken"  id="photoTaken" ref="canvas" :width="100" :height="100">{{ imageFile }}</canvas>
                        </v-col>
                        <v-btn color="primary"  @click="showImage">انتخاب عکس </v-btn>
                    </v-row> -->

                    <v-row class="mt-2">
                        <v-col cols="12" sm="12">
                            <v-row>
                                <v-col class="max-width-text-title px-1 d-flex">
                                    <label class="my-auto">{{ $t("description") }} : </label>
                                </v-col>
                                <v-col>
                                    <v-textarea solo dense hide-details="" ref="description" v-model="ioParams.Description"
                                        auto-grow :placeholder="$t('description')" rows="2"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-form>
                <!-- <IntervalIoCamera @imageData="handleImageData" class="py-2"/> -->
                <div id="camera" class="web-camera-container px-3 pt-2">

                    <!-- <div class="camera-button">
      <button type="button" class="button is-rounded"
          :class="{ 'is-primary': !isCameraOpen, 'is-danger': isCameraOpen }" @click="toggleCamera">
          <span v-if="!isCameraOpen">Open Camera</span>
          <span v-else>Close Camera</span>
      </button>
  </div>
  
  <div v-show="isCameraOpen && isLoadingCamera" class="camera-loading">
      <ul class="loader-circle">
          <li></li>
          <li></li>
          <li></li>
      </ul>
  </div> -->

                    <div v-if="isCameraOpen" v-show="!isLoadingCamera" class="camera-box" :class="{ flash: isShotPhoto }">
                        <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

                        <video v-show="!isPhotoTaken" ref="camera" :width="originalWidth" :height="originalHeight"
                            autoplay></video>

                        <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="originalWidth"
                            :height="originalHeight"></canvas>
                    </div>

                    <!-- <div v-if="isCameraOpen && !isLoadingCamera" class="camera-shoot">
          <v-btn dark color="teal" @click="takePhoto" class="button">
              <v-icon larg>mdi-camera</v-icon>
          </v-btn>
  
      </div> -->

                    <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
      <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
          تایید
      </a>
  </div>
  <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
      <a  class="button" role="button" @click="showAgain">
      دوباره
      </a>
  </div> -->


                </div>

                <v-card-actions class="px-0 pt-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="showWorkCalndar = !showWorkCalndar">{{
                        $t("workCalendar")
                    }}</v-btn>
                    <v-btn color="primary" @click="showIntervalIOList">{{
                        $t("nav-interval-io")
                    }}</v-btn>
                    <!-- <v-btn color="primary" :disabled="!haveImage" :loading="isLoading" @click="addIO">{{ $t("submit") }}</v-btn> -->
                    <v-btn color="primary" :disabled="!disBtn" :loading="isLoading" @click="addIO">{{ $t("submit") }}</v-btn>
                </v-card-actions>
            </div>
        </box>




        <IntervalIOList ref="intervalIOList" class="py-2" :visible="IntervalIOListVisibility" />
        <WorkCalendar :showWorkCalndar="showWorkCalndar" :perno="this.perno" />
        <label>
            {{ errorMsg }}
        </label>
    </div>
</template>
  
<script>
import IntervalIOList from "../../components/io/IntervalIO/IntervalIOList.vue";
import WorkCalendar from "../../components/request/WorkCalendar.vue";
// import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
// import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";
// import IntervalIoCamera from"../../components/io/IntervalIO/InternalIOCamera.vue";
// import Camera from 'vue-Camera';

export default {
    components: {
        WorkCalendar,
        //   DialogDatePicker,
        //   DialogTimePicker,
        IntervalIOList,
        //   IntervalIoCamera,
        // Camera,
    },
    mounted() {
        this.isCameraOpen = true;
        this.createCameraElement();
        this.pageLoad();
        this.checkDescriptionRules();
        this.getArgs();
        // this.runNavigator();

    },
    data() {
        return {
            args: {},
            ioParams: {
                IoKind: "1",
            },
            showWorkCalndar: false,
            errorMsg: '',
            form: false,
            haveImage: false,
            isLoading: false,
            initBeginDate: null,
            beginDate: "",
            beginTime: "",
            //   initBeginTime: "",
            IntervalIOListVisibility: false,
            perno: "",
            clockVisible: false,
            clockList: [],
            selectedClock: "",
            // 
            isCameraActive: false,
            dateTime: '',
            timer: null,
            countDown: 10,
            imageFile: null,
            isCameraOpen: false,
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoadingCamera: false,
            disBtn: true,
            link: "#",
            originalWidth: 250,
            originalHeight: 337.5

            // isCameraOpen: false,
            // isPhotoTaken: false,
            // isShotPhoto: false,
            // isLoadingCamera: false,
            // link: "#",
        };
    },
    methods: {
        pageLoad() {
            this.loadClock();
        },
        async loadClock() {
            await this.$store.dispatch("getClockSelection").then((result) => {
                if (result.type === ResultType.success) {
                    this.clockVisible = result.data;
                }
            })
                .catch((error) => {
                    console.error('getClockSelection', error)
                    this.errorMsg = 'getClockSelection :' + error
                });

            if (this.clockVisible) {
                this.$store.dispatch("getClocksList").then((result) => {
                    console.log(result);
                    if (result.type === ResultType.success) {
                        this.clockList = result.data;
                        if (this.clockList.length > 0) {
                            if (this.details) {
                                var selected = this.clockList.find(
                                    (item) => item.Code == this.details.Code
                                );
                                if (selected) {
                                    this.selectedClock = selected;
                                }
                            } else {
                                this.selectedClock = this.clockList[0];
                            }
                        }
                    }
                })
                    .catch((error) => {
                        console.error('getClocksList', error)
                        this.errorMsg = 'getClocksList :' + error
                    });
            }


            //   const success = async (position) => {
            //     debugger

            //   };
            //   const error = (err) => {
            //       console.log(err);
            //       //alert(err);
            //   };


        },
        // runNavigator() {
        //     navigator.geolocation.getCurrentPosition(this.getDate());
        // },
        // getDate(position) {
        //     debugger
        //     // this.initBeginDate=position
        //     // var dateTimeResult=position.timestamp
        //     // var dataTime = new Date(timestamp).toLocaleString();
        //     var datetime = new Date(position.timestamp).toLocaleDateString("fa-IR");
        //     console.log("Resulttimestamp" + datetime.toString())

        // },



        getArgs() {
            this.args = this.$route.params.details;
            if (this.args) {
                this.loadRegistration(this.args);
            }

            if (this.args && this.args.selectedPerno) {
                this.perno = this.args.selectedPerno;
            }

            var selectedDate = this.$route.query.SD;
            debugger;
            if (selectedDate) {
                this.initBeginDate = this.beginDate = selectedDate;
            }
        },

        loadRegistration(args) {
            const params = new URLSearchParams();
            params.append("id", TextUtils.convertToEnglishDigits(args.PageNo));
            //params.append("dbkind", args.DBKind);
            params.append("year", args.Year);
            params.append("perno", args.selectedPerno || "");
            this.$store.dispatch("GetIoDetail", { params }).then((result) => {
                if (result.type == "success") {
                    if (result.data.length > 0) {
                        this.details = result.data[0];
                        this.details.Year = args.Year;
                        this.ShowIODetailForEdit(this.details);
                    }
                }
            });
        },

        ShowIODetailForEdit(details) {
            this.ioParams.PageNo = details.Id.toString().trim();
            this.ioParams.Description = details.UserDescription;
            this.ioParams.IoKind = details.Io_Type;

            //   this.initBeginDate = this.beginDate = details.ClockDate;
            //   this.initBeginTime = this.beginTime = details.ClockTime;

            this.loadClock();
        },

        bDate(date) {
            this.beginDate = date;
        },

        bTime(date) {
            this.beginTime = date;
        },

        addIO() {
            this.takePhoto();
            this.downloadImage();
            // if (!this.isPhotoTaken) {
            //     this.isShotPhoto = true;

            //     const FLASH_TIMEOUT = 50;

            //     setTimeout(() => {
            //         this.isShotPhoto = false;
            //     }, FLASH_TIMEOUT);
            // }

            // this.isPhotoTaken = !this.isPhotoTaken;

            // const context = this.$refs.canvas.getContext("2d");
            // context.drawImage(this.$refs.camera, 0, 0, this.originalWidth, this.originalHeight);
            //

            var GeoFenceCount = this.$store.state.lock.lockData.GeoFenceCount;
            if (this.$isMobile() && GeoFenceCount && Number(GeoFenceCount) > 0) {
                this.AddIoWithLocation();
                
            } else {
                //this.addIOWithoutLocation();
                this.$EosToast.show({
                    type: EosToastType.error,
                    msg: "error",
                });
            }
            this.disBtn=false;

            this.stopCameraStream();

            
             setTimeout(() => {
                this.$router.push({ name: "profile" });
                 }, 4000);

           
        },

        async AddIoWithLocation() {

            //for test if you have Problem with send image
            // var data = {
            //     InDate: this.beginDate,
            //     InTime: this.beginTime,
            //     Description: this.ioParams.Description || "",
            //     IoKind: this.ioParams.IoKind,
            //     Id: this.ioParams.PageNo || "",
            //     //   lon: longitude,
            //     //   lat: latitude,
            //     Image: this.receivedImageData,

            // };
            // if (this.args?.selectedPerno) {
            //     data.Perno = this.args.selectedPerno;
            // }
            // if (this.clockVisible) {
            //     data.ClockValue = `${this.selectedClock.Code},${this.selectedClock.MachineNo}`;
            // }
            // this.$store
            //     .dispatch("geolocation/AddIoWithLocation", {
            //         data: data,
            //     })
            //     .then((result) => {
            //         //console.log(result);
            //         //alert(JSON.stringify(result));
            //         if (result.type === ResultType.success) {
            //             this.$EosToast.show({
            //                 type: EosToastType.success,
            //                 msg: this.$t("msg-registration-success", {
            //                     opName: this.$t("nav-request-io"),
            //                 }),
            //             });
            //             this.$refs.form.reset();



            //             if (this.ioParams.PageNo && this.args && this.args.from) {
            //                 this.$router.push({ name: this.args.from });
            //             }
            //         } else {
            //             this.$EosToast.show({
            //                 type: EosToastType.error,
            //                 msg: result.error || "error",
            //             });
            //         }
            //     })
            //     .catch((error) => {
            //         console.error('geolocation/AddIoWithLocation', error)
            //         this.errorMsg = 'geolocation/AddIoWithLocation : ' + error
            //     });
            // END



            const success = async (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                //   var utc=position.timestamp;
                //   var resultText=this.receivedImageData;
                //   this.$EosToast.show({
                //       type: EosToastType.success,
                //       msg: resultText,
                //   });


                debugger
                // console.log("utc"+utc)
                var isValidLocation = false;
                var isValidLocationRes = await this.$store.dispatch(
                    "geolocation/isValidLocation",
                    {
                        data: {
                            Longtitude: longitude,
                            Latitude: latitude,
                        },
                    }
                );
                if (isValidLocationRes.type == ResultType.success) {
                    isValidLocation = isValidLocationRes.data;
                }

                if (isValidLocation) {

                    var data = {
                        InDate: this.beginDate,
                        InTime: this.beginTime,
                        Description: this.ioParams.Description || "",
                        IoKind: this.ioParams.IoKind,
                        Id: this.ioParams.PageNo || "",
                        lon: longitude,
                        lat: latitude,
                        Image: this.receivedImageData,

                    };
                    if (this.args?.selectedPerno) {
                        data.Perno = this.args.selectedPerno;
                    }
                    if (this.clockVisible) {
                        data.ClockValue = `${this.selectedClock.Code},${this.selectedClock.MachineNo}`;
                    }
                    this.$store
                        .dispatch("geolocation/AddIoWithLocation", {
                            data: data,
                        })
                        .then((result) => {
                            //console.log(result);
                            //alert(JSON.stringify(result));
                            if (result.type === ResultType.success) {
                                this.$EosToast.show({
                                    type: EosToastType.success,
                                    msg: this.$t("msg-registration-success", {
                                        opName: this.$t("nav-request-io"),
                                    }),
                                });
                                this.$refs.form.reset();



                                if (this.ioParams.PageNo && this.args && this.args.from) {
                                    this.$router.push({ name: this.args.from });
                                }
                               
                            } else {
                                this.$EosToast.show({
                                    type: EosToastType.error,
                                    msg: result.error || "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error('geolocation/AddIoWithLocation', error)
                            this.errorMsg = 'geolocation/AddIoWithLocation : ' + error
                        });
                } else {
                    this.$EosToast.show({
                        type: EosToastType.error,
                        msg: "خارج از محدوده جغرافیایی تعریف شده نمی توانید درخواست بدهید",
                    });
                }
            };

            const error = (err) => {
                console.log(err);
                //alert(err);
            };

            // This will open permission popup
            navigator.geolocation.getCurrentPosition(success, error);

        },

        checkDescriptionRules() {
            var IsCommentRequired =
                this.$store.state.settings.settings.IsCommentRequiredForIo;
            if (IsCommentRequired == 1) {
                this.$refs.description.rules = [this.$rules.required];
            }
        },

        showIntervalIOList() {
            if (this.IntervalIOListVisibility == false) {
                this.$refs.intervalIOList.showIntervalDays(2, this.beginDate);
            }
            this.IntervalIOListVisibility = !this.IntervalIOListVisibility;
        },


        // toggleCamera() {
        //   if (this.isCameraOpen) {
        //     this.isCameraOpen = false;
        //     this.isPhotoTaken = false;
        //     this.isShotPhoto = false;
        //     this.stopCameraStream();
        //   } else {
        //     this.isCameraOpen = true;
        //     // this.isShotPhoto = true;
        //     this.createCameraElement();
        //   }
        // },

        // createCameraElement() {
        //   this.isLoading = true;

        //   // const constraints = (window.constraints = {

        //   // });

        //   navigator.mediaDevices
        //     .getUserMedia({ video: true})
        //     .then((stream) => {
        //       this.isLoading = false;
        //       this.$refs.camera.srcObject = stream;
        //       // this.$refs.videoElemet.srcObject = stream;

        //     })
        //     .catch((error) => {
        //       this.isLoading = false;
        //       alert("May the browser didn't support or there is some errors.");
        //       console.log(error)
        //     });
        // },

        // stopCameraStream() {
        //   let tracks = this.$refs.camera.srcObject.getTracks();

        //   tracks.forEach((track) => {
        //     track.stop();
        //   });
        // },

        // takePhoto() {
        //   if (!this.isPhotoTaken) {
        //     this.isShotPhoto = true;

        //     const FLASH_TIMEOUT = 50;

        //     setTimeout(() => {
        //       this.isShotPhoto = false;
        //     }, FLASH_TIMEOUT);
        //   }

        //   this.isPhotoTaken = !this.isPhotoTaken;

        //   const context = this.$refs.canvas.getContext("2d");
        //   context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
        // },

        // downloadImage() {
        //   const download = document.getElementById("downloadPhoto");
        //   const canvas = document
        //     .getElementById("photoTaken")
        //     .toDataURL("image/jpeg")
        //     .replace("image/jpeg", "image/octet-stream");
        //   download.setAttribute("href", canvas);
        // },

        // openCmera() {
        //     this.isCameraActive = true;
        //     this.timer = setInterval(this.countDownTimer, 1000);
        //     // 
        //     debugger
        //     navigator.mediaDevices.getUserMedia({ video: true })
        //         .then((stream) => {
        //             const videoElement = this.$refs.videoElement;
        //             videoElement.srcObject = stream;

        //         })
        //         .catch((error) => {
        //             console.error('خطا در بازکردن دوربین ', error)
        //         })
        // },

        // countDownTimer() {
        //     if (this.countDown > 0) {
        //         this.countDown--;
        //     }
        //     else {
        //         clearInterval(this.timer)
        //         this.stopCamera();
        //     }
        // },

        // stopCamera() {
        //     this.isCameraActive = false;
        //     navigator.geolocation.getCurrentPosition(this.getLocationSuccess, this.getLocationError)
        // },

        // getLocationSuccess(position) {
        //     const { latitude, longitude } = position.coords;
        //     const date = new Date();
        //     const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        //     const formattedTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
        //     this.dateTime = `${formattedDate} ${formattedTime} (Lat: ${latitude}, Lng: ${longitude})`;
        // },

        // getLocationError(error) {
        //     console.log(error);
        // },
        //   showImage(){
        //     debugger
        //     const canvas = document
        //             .getElementById("photoTaken");
        //     const context=canvas.getContext("2d");
        //             const image= new Image();
        //             image.src = canvas.toDataURL("image/jpeg")

        //             image.onload = () => {
        //             context.clearRect(0, 0, canvas.width, canvas.height);
        //             canvas.width = image.width;
        //             canvas.height = image.height;
        //             context.drawImage(image, 0, 0,this.originalWidth, this.originalHeight);

        //             const imageData = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        //             this.receivedImageData=imageData
        //             console.log(imageData);
        //             debugger;
        //              this.haveImage = true;
        //   }
        // },
        //   handleImageData(imageData) {
        //   this.receivedImageData = imageData;
        //   if (this.receivedImageData) {
        //             this.haveImage = true;
        //         }
        //         else {
        //             this.haveImage = false;

        //         }

        //     },

        // toggleCamera() {
        //     if (this.isCameraOpen) {
        //         this.isCameraOpen = false;
        //         this.isPhotoTaken = false;
        //         this.isShotPhoto = false;
        //         this.stopCameraStream();
        //     } else {
        //         this.isCameraOpen = true;
        //         // this.isShotPhoto = true;
        //         this.createCameraElement();
        //     }
        // },

        createCameraElement() {
            this.isLoadingCamera = true;

            // const constraints = (window.constraints = {

            // });

            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then((stream) => {
                    this.isLoadingCamera = false;
                    this.$refs.camera.srcObject = stream;
                    // this.$refs.videoElemet.srcObject = stream;

                })
                .catch((error) => {
                    this.isLoadingCamera = false;

                    alert("May the browser didn't support or there is some errors.");
                    console.log(error)
                });
        },

        stopCameraStream() {
            let tracks = this.$refs.camera.srcObject.getTracks();

            tracks.forEach((track) => {
                track.stop();
            });
        },

        takePhoto() {

            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }

            this.isPhotoTaken = !this.isPhotoTaken;

            const context = this.$refs.canvas.getContext("2d");
            context.drawImage(this.$refs.camera, 0, 0, this.originalWidth, this.originalHeight);
        },

        // showAgain(){
        //     // this.isCameraOpen = false;
        //     // this.isPhotoTaken = false;
        //     // this.isShotPhoto = false;
        //     // this.stopCameraStream();
        //     // this.isCameraOpen = true;
        //     // this.isShotPhoto = true;
        //     // this.createCameraElement();
        //    this.toggleCamera;

        // },
        downloadImage() {
            // const download = document.getElementById("downloadPhoto");
            // const canvas = document
            //     .getElementById("photoTaken")
            //     .toDataURL("image/jpeg")
            //     .replace("image/jpeg", "image/octet-stream");
            // download.setAttribute("href", canvas);
            // const download = document.getElementById("downloadPhoto");
            const canvas = document
                .getElementById("photoTaken");
            const context = canvas.getContext("2d");
            const image = new Image();
            image.src = canvas.toDataURL("image/jpeg")
            // image.src = canvas.toDataURL("image/jpeg", 0.005)

            image.onload = () => {
                // context.clearRect(0, 0, canvas.width, canvas.height);
                // context.clearRect(0, 0, this.originalWidth, this.originalWidth);
                // canvas.width = image.width;
                // canvas.height = image.height;
                // canvas.width = this.originalWidth;
                // canvas.height = this.originalWidth;
                context.drawImage(image, 0, 0, this.originalWidth, this.originalHeight);

                this.receivedImageData = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");


                // debugger
                // this.$emit("imageData", imageData);
            };
        }




    },
};
</script>
  
<style scoped>
.max-width-text-title {
    max-width: 100px;
}

.clock-header {
    background: #f2f2f2;
}

body {
    display: flex;
    justify-content: center;
}

.web-camera-container {
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* width: 400px; */
}

.web-camera-container .camera-button {
    margin-bottom: 2rem;
}

.web-camera-container .camera-box .camera-shutter {
    opacity: 0;
    width: 450px;
    height: 337.5px;
    background-color: #fff;
    position: absolute;
}

.web-camera-container .camera-box .camera-shutter.flash {
    opacity: 1;
}

.web-camera-container .camera-shoot {
    margin: 1rem 0;
}

.web-camera-container .camera-shoot button {
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
}

.web-camera-container .camera-shoot button img {
    height: 35px;
    object-fit: cover;
}

.web-camera-container .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;
}

.web-camera-container .camera-loading ul {
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 999999;
    margin: 0;
}

.web-camera-container .camera-loading .loader-circle {
    display: block;
    height: 14px;
    margin: 0 auto;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    transform: translateX(-50%);
    position: absolute;
    width: 100%;
    padding: 0;
}

.web-camera-container .camera-loading .loader-circle li {
    display: block;
    float: left;
    width: 10px;
    height: 10px;
    line-height: 10px;
    padding: 0;
    position: relative;
    margin: 0 0 0 4px;
    background: #999;
    animation: preload 1s infinite;
    top: -50%;
    border-radius: 100%;
}

.web-camera-container .camera-loading .loader-circle li:nth-child(2) {
    animation-delay: 0.2s;
}

.web-camera-container .camera-loading .loader-circle li:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes preload {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.4;
    }

    100% {
        opacity: 1;
    }
}
</style>
  
  
  
  
  
  
  
  
  
  
  